import { ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, HostBinding, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { TranslationService } from './shared/services/i18n/translation.service';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { genericCustomStoreService } from './shared/services/genericCustomStore.service';
import { SignalRService } from './signal-r.service';
import { ThemeService } from './theme.service';
import { filter } from 'rxjs';
import { DxDataGridComponent } from 'devextreme-angular';
import { PermissionAction, PermissionService } from './shared/services/permission.service';
import { RouteService } from './shared/services/route.service';
import { RequestTrackerService } from './request-tracker-service.service';

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  viewContainerRef: any;
  canAdd: any;
  canEdit: any;
  canDelete: any;
  controllerName: string;
  not: any;
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }
  languages = ["en", "ar"];
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  browserLang: any;

  public isLoading = false;
  currentLang: any;
  message: string = "";
  iconClass: string = 'icon-default';
  currentRoute: string = '';
  dynamicRouteParams: any = {};
  @ViewChild('grid', { static: false }) grid: DxDataGridComponent;
  constructor(private themeService: ThemeService,private authService: AuthService, public route: ActivatedRoute, private url: LocationStrategy,
    private screen: ScreenService, public appInfo: AppInfoService, public router: Router,public gt:genericCustomStoreService,
    private translate: TranslateService,private tracker: RequestTrackerService ,private signalrservice:SignalRService,public permissionService :PermissionService,public routee: ActivatedRoute,
    public translationService: TranslationService ,public cdRef: ChangeDetectorRef,public routeService:RouteService,
    private activatedRoute: ActivatedRoute,
    private resolver: ComponentFactoryResolver) { 
      this.translate.addLangs(this.languages);
     this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );
    if (this.currentLang !== null && this.currentLang !== undefined) {
      this.translate.use(this.currentLang);

      let direction =
        localStorage.getItem(this.LOCALIZATION_LOCAL_STORAGE_KEY) === "ar"
          ? "rtl"
          : "ltr";
      document.documentElement.dir = direction;
      document.documentElement.lang = this.currentLang;

      let dirclass = localStorage.getItem(this.LOCALIZATION_LOCAL_STORAGE_KEY) === "ar"
        ? "dx-rtl"
        : "";

      let getMain = document.getElementsByTagName("html")[0];
      getMain.setAttribute("lang", this.currentLang);
      getMain.setAttribute("class", dirclass);
    } else {
      this.browserLang = this.translate.getBrowserLang();
      localStorage.setItem(
        this.LOCALIZATION_LOCAL_STORAGE_KEY,
        this.browserLang
      );
      this.translate.use(this.browserLang);
      this.translate.setDefaultLang(this.browserLang);
      window.location.reload();
    }
      this.tracker.isLoading$.subscribe((status) => {
    this.isLoading = status;
    this.cdRef.detectChanges(); // Trigger change detection if needed
  });

  
    // get routing
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     console.log((event as NavigationStart).url);
    //     let sessiondata:any = sessionStorage.getItem("data");
    //     let data = JSON.parse(sessiondata);
    //      data = data?.navihationMenu
    //     //make parent and child from data
    //     if (data) {
    //       let activePath=data.find((ele: any) => {
    //         return `/${ele.externalUrl}` == (event as NavigationStart).url
    //       })
    //       localStorage.setItem('activePath',activePath)
    //     }
    //   }
    // });

    this.signalrservice.messageReceived.subscribe((message) => {
      this.message = message;
      if (this.message != "" && this.message != undefined) {
        this.iconClass = "icon-active"
      }
      console.log(this.message);
    });
    
  }
  ngOnInit() {
    // Apply theme on initialization
  //  this.themeService.applyTheme();
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe((event: NavigationEnd) => {
    //   this.currentRoute = event.urlAfterRedirects.startsWith('/')
    //     ? event.urlAfterRedirects.substring(1) // Remove leading slash
    //     : event.urlAfterRedirects;
      
    //   console.log('Current Route:', this.currentRoute);
    // });
    // this.routeService.currentRoute$.subscribe(route => {
    //   this.currentRoute=route;
    //   console.log('Current Route:', route); // Logs "parent/child"
    // });
    // // Subscribe to NavigationEnd event to automatically refresh on route change
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.refreshRouterOutlet();
    //   }
    // });
     // Listen for route changes
     this.router.events
     .pipe(filter(event => event instanceof NavigationEnd))
     .subscribe((event: NavigationEnd) => {
       const rawRoute = event.urlAfterRedirects;
       this.currentRoute = rawRoute.startsWith('/') ? rawRoute.slice(1) : rawRoute;
       this.refreshRouterOutlet();
     });

   // Also listen to custom routeService
   this.routeService.currentRoute$.subscribe(route => {
     this.currentRoute = route;
     console.log('RouteService emitted route:', route);
   });
    
  }

  isAuthenticated() {
    return this.authService.loggedIn;
  }

  refreshRouterOutlet() {
    console.log('Router outlet refreshed');
    this.onRouterOutletActivate(null);
  }

  onRouterOutletActivate(component: any) {
    console.log('Router outlet activated:', component);
    if (component) {
      this.applyGridPermissions(component);
    } else {
      console.log('No component to activate.');
    }
  }

  applyGridPermissions(component: any): boolean {
    if (!component) {
      console.warn('Component is undefined or null.');
      return false;
    }

    const gridKey = 'grid' as keyof typeof component;

    setTimeout(() => {
      const gridInstance = component[gridKey]?.instance;
    
      if (!gridInstance) {
        console.warn('Grid instance not found on component.');
        return;
      }
    
      const { allowAdding, allowUpdating, allowDeleting } = this.gt.getPermissionsForRoute(this.currentRoute);
    
      gridInstance.option('editing', {
        allowAdding,
        allowUpdating,
        allowDeleting
      });
      console.log('Applying permissions:', { allowAdding, allowUpdating, allowDeleting });

      console.log('Grid permissions applied successfully.');
    }, 0);
    
    return true;
  }

  hasPermission(permissions: PermissionAction[], permissionName: string): boolean {
    return permissions.some(p => p.name === permissionName && p.isAvailable);
  }
}
  
  

  

